import { themeVars } from '@tundr/theme';
import { style, styleVariants } from '@vanilla-extract/css';
import { InputSizeVariant } from '../InputWrapper';

export const datePickerBaseClass = style({});

export const customDatePickerMenuClass = style({
  boxShadow: themeVars.shadow.elevationSmall,
  borderRadius: themeVars.radius.md,
  overflow: 'hidden',
});

export const calendarIconClass = style({
  cursor: 'pointer',
  fontSize: themeVars.font.size.textLg,
  position: 'relative',
});

export const datePickerInputClass = style({
  cursor: 'pointer !important',
});

export const calendarIconSizeClass = styleVariants({
  [InputSizeVariant.SMALL]: {
    top: 0,
    right: 0,
  },
  [InputSizeVariant.DEFAULT]: {
    top: 4,
    right: 4,
  },
});
